<div class="main">
  <div class="container">
    <app-header></app-header>
    <div class="content">
      <ng-content></ng-content>
    </div>
  </div>
</div>
